import { render, staticRenderFns } from "./WhitelabelList.vue?vue&type=template&id=4970bb44&"
import script from "./WhitelabelList.vue?vue&type=script&lang=ts&"
export * from "./WhitelabelList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports